(function() {
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;
  
  history.pushState = function(state, title, url) {
    const originalURL = url
    if (typeof url === 'string') {
      url = url.replace(/\/{2,}/g, '/');
    }
    return originalPushState.call(this, state, title, url);
  };
  
  history.replaceState = function(state, title, url) {
    const originalURL = url
    if (typeof url === 'string') {
      url = url.replace(/\/{2,}/g, '/');
      if (url !== originalURL) {
        window.location.href = url
      }
    }
    return originalReplaceState.call(this, state, title, url);
  };
})();